import React, { createContext, useContext } from 'react'

import { EditPriceModal } from '../../cart/components/EditPriceModal'
import { CartItem } from '../../cart/storage/cart.types'
import { useAppDispatch } from '../../../store/rootStore'
import { editPrice, revertPrice } from '../storage/seedCartThunk'

const SeedEditPriceModalContext = createContext<
  | {
      setOpen: React.Dispatch<React.SetStateAction<boolean>>
      setItem: React.Dispatch<React.SetStateAction<CartItem | undefined>>
      setAccountNumber: React.Dispatch<React.SetStateAction<string | undefined>>
    }
  | undefined
>(undefined)

export const useSeedEditPriceModal = () => {
  const context = useContext(SeedEditPriceModalContext)
  if (!context) {
    throw new Error('useSeedEditPriceModal must be used within a SeedEditPriceProvider')
  }
  return context
}

type SeedEditPriceProviderProps = {
  children?: React.ReactNode
}

export const SeedEditPriceProvider: React.FC<SeedEditPriceProviderProps> = ({ children }) => {
  const [open, setOpen] = React.useState(false)
  const [item, setItem] = React.useState<CartItem>()
  const [accountNumber, setAccountNumber] = React.useState<string>()

  const dispatch = useAppDispatch()

  const value = React.useMemo(() => {
    return { setOpen, setItem, setAccountNumber }
  }, [setOpen, setItem, setAccountNumber])

  const onApplyEditedPrince = (newPrice: number, newQuantity: number, item: CartItem) => {
    if (accountNumber) {
      dispatch(editPrice({ item, newPrice, newQuantity, accountNumber }))
    }
  }

  const onRevertEditedPrice = (item: CartItem) => {
    if (accountNumber) {
      dispatch(revertPrice({ item, accountNumber }))
    }
  }

  return (
    <SeedEditPriceModalContext.Provider value={value}>
      {children}
      <EditPriceModal
        open={open}
        setOpen={setOpen}
        item={item}
        cartProductCardProps={{
          enableQuantity: false,
          enableRemove: false,
          enableVariants: false,
        }}
        onApplyEditedPrince={onApplyEditedPrince}
        onRevertEditedPrice={onRevertEditedPrice}
      ></EditPriceModal>
    </SeedEditPriceModalContext.Provider>
  )
}

export default SeedEditPriceProvider
